(() => {
  const selectors = [
    '[data-nakr-drag]', '.sev-track', '.sekany-eps__track', '.sekany-ap-rail__track',
    '.nakr-cross__rail', '.nakr-newdrops__strip', '.nakr-newdrops__grid',
    '.nakr-world__postcards-track', '[id^="SekanyHome-"] .sh-product-track',
    '[id^="SekanyHome-"] .sh-material', '.product__media-list', '.thumbnail-list', '.nakr-qv__media'
  ];
  const enhance = (root = document) => {
    root.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (el.dataset.nakrTouchQa === '1') return;
      el.dataset.nakrTouchQa = '1';
      el.style.webkitOverflowScrolling = 'touch';
      el.style.touchAction = 'pan-x pan-y pinch-zoom';
      /* Deliberately no touchstart/touchmove preventDefault: native vertical scroll must remain free. */
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();

/* V202 viewport/header safety for iOS drawers */
(() => {
  const setHeaderHeight = () => {
    const header = document.querySelector('.header-wrapper, sticky-header, header');
    if (!header) return;
    const h = Math.round(header.getBoundingClientRect().height || 64);
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener('orientationchange', setHeaderHeight, { passive: true });
})();
